import { ApiEpBilling, IApiEpBillingPlansubscriptionListReq } from "@smp/api";
import { useQuery } from "react-query";

const KEY = "ep.billing.plansubscription";

export const useEpBillingPlansubscriptionList = (options?: {
  req?: IApiEpBillingPlansubscriptionListReq;
}) => {
  const {
    data: plansubscriptionListRes,
    isLoading: isPlansubscriptionListLoading,
  } = useQuery([KEY, options?.req], () =>
    ApiEpBilling.Plansubscription.list(options?.req),
  );

  const plansubscriptionList = plansubscriptionListRes?.results;

  return { isPlansubscriptionListLoading, plansubscriptionList };
};

useEpBillingPlansubscriptionList.KEY = KEY;
